export default __webpack_public_path__ + "static/media/play.37578a03.svg";